import { EDevFlag } from '@/constants';
import { queryClient } from '@/context/CombinedProvider';

import {
  ECareType,
  EClaimCreationStatus,
  EClaimType,
  EPatientRelationship,
  IAllClaimsListQuery,
  IAvailableClaimType,
  IClaimDetails,
  IClaimPNRD,
  IClaimsCount,
  IClaimsListQuery,
  IImportedCashlessClaims,
  IMutationQuery,
  IQuery,
  ISignedUrl,
} from '@/types';
import {
  claimsAxiosInstance,
  decodeAuthToken,
  gatewayAxiosInstance,
} from '@/utils';
import { addDays } from 'date-fns';

// const DELETIONS = {};

// const getMockClaimDetails = () => ({
//   amount: null,
//   amountApproved: null,
//   plumClaimId: 'AB8092',
//   insurerClaimId: null,
//   insurerClaimReferenceNo: null,
//   insurerImported: null,
//   insurerOfflineClaimReferenceNo: null,
//   isClaimSubmittedByAPI: null,
//   duplicateRefId: null,
//   memberId: '4xls4ji5lF2ukOFcuezj',
//   memberName: 'Only  Spouse',
//   organisationId: 'uGkTeDJMIdryu4xSQU4w',
//   organisationName: 'Raj digital limited',
//   organisationBenefitId: '8HdttcWTgFTLXVlVES3i',
//   typeOfBenefit: 'health-expenses',
//   insuranceProviderHandle: 'plum',
//   insuranceProviderPartner: null,
//   tpaName: null,
//   docConfig: 2,
//   isClaimDigitised: false,
//   isClaimPreDigitised: false,
//   digitisationSuccessful: null,
//   instructionsPopupSeenFlagList: null,
//   patientName: 'Only  Spouse',
//   patientId: '4xls4ji5lF2ukOFcuezj',
//   patientRelationship: 'self',
//   patientGender: 'male',
//   whoIsPatient: null,
//   whatIsPatientName: null,
//   covidTestResult: null,
//   emergency: null,
//   typeOfClaim: 'Reimbursement',
//   typeOfCare: 'OPD',
//   typeOfTreatment: null,
//   dateOfAdmission: '2024-11-09T05:30:00Z',
//   treatmentDuration: null,
//   dateOfDischarge: null,
//   dateOfAdmissionObject: null,
//   dateOfDischargeObject: null,
//   tentativeDaysToDateOfAdmisson: null,
//   tentativeDaysToDateOfDischarge: null,
//   treatmentStage: null,
//   reasonForHospitalization: 'test',
//   modeOfSubmission: 'digital',
//   dateOfConsultation: null,
//   reasonForConsulation: null,
//   stage: 'documents-requested',
//   claimExternalStatus: null,
//   externalStatusDesc: null,
//   source: 'Plum iOS',
//   deleted: false,
//   isClosed: false,
//   canDelete: true,
//   isTest: true,
//   vip: false,
//   claimCourierPending: null,
//   createdAt: '2024-11-27T11:39:04.392399Z',
//   updatedAt: '2024-11-27T11:39:04.392421Z',
//   closedAt: null,
//   read: false,
//   fullfilled: {
//     'documents-requested': {
//       date: '2024-11-27T11:39:04.677752Z',
//       '0': '2024-11-27T11:39:04.677752Z',
//     },
//   },
//   expected: {},
//   statusContent: {
//     contentVariables: {
//       disputedChildClaimId: '',
//       tat: {
//         'paid-closed': 'paid+1w',
//         'documents-ok': 'documents-submitted+1w',
//         'plum-rejected-closed': 'plum-rejected+1w',
//         approved: 'under-investigation+21w,query-raised+3w,claim-submitted+3w',
//         'claim-submitted': 'documents-ok+1w,documents-submitted+1w',
//         'rejected-closed': 'rejected+1w',
//         paid: 'approved+5w',
//       },
//       emailNote: '',
//     },
//     followupWhatsAppNotifications: [
//       {
//         deleteIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '!=',
//                 value: 'documents-requested',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//         type: 'reim-claim-documents-requested-followup-t+1',
//         sendIfConditionsTrue: [
//           {
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '==',
//                 value: 'documents-requested',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '28-Nov-2024',
//               },
//             ],
//             reference: 'document',
//           },
//         ],
//         notificationPayload: {
//           templateName: 'reim_claim_documents_requested_notify_t_plus_1_v2',
//           templateParams: {
//             body: {
//               params: ['Only', '27-Nov-2024'],
//             },
//             header: {
//               params: [],
//             },
//             buttons: [
//               {
//                 params: ['AB8092/upload'],
//               },
//             ],
//           },
//         },
//       },
//       {
//         notificationPayload: {
//           templateParams: {
//             header: {
//               params: [],
//             },
//             buttons: [
//               {
//                 params: ['AB8092/upload'],
//               },
//             ],
//             body: {
//               params: ['Only', '27-Nov-2024'],
//             },
//           },
//           templateName: 'reim_claim_documents_requested_notify_t_plus_2_v2',
//         },
//         deleteIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 operator: '!=',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//         type: 'reim-claim-documents-requested-followup-t+2',
//         sendIfConditionsTrue: [
//           {
//             conditions: [
//               {
//                 operator: '==',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '29-Nov-2024',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//           },
//         ],
//       },
//       {
//         deleteIfConditionsTrue: [
//           {
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 operator: '!=',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//             ],
//             reference: 'document',
//           },
//         ],
//         type: 'reim-claim-documents-requested-followup-t+4',
//         sendIfConditionsTrue: [
//           {
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '==',
//                 value: 'documents-requested',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '01-Dec-2024',
//               },
//             ],
//             reference: 'document',
//           },
//         ],
//         notificationPayload: {
//           templateName: 'reim_claim_documents_requested_notify_t_plus_4_v2',
//           templateParams: {
//             body: {
//               params: ['Only', '27-Nov-2024'],
//             },
//             header: {
//               params: [],
//             },
//             buttons: [
//               {
//                 params: ['AB8092/upload'],
//               },
//             ],
//           },
//         },
//       },
//       {
//         deleteIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 operator: '!=',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//         type: 'reim-claim-documents-requested-followup-t+7',
//         sendIfConditionsTrue: [
//           {
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '==',
//                 value: 'documents-requested',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '04-Dec-2024',
//               },
//             ],
//             reference: 'document',
//           },
//         ],
//         notificationPayload: {
//           templateName: 'reim_claim_documents_requested_notify_t_plus_7_v2',
//           templateParams: {
//             body: {
//               params: ['Only', '27-Nov-2024'],
//             },
//             header: {
//               params: [],
//             },
//             buttons: [
//               {
//                 params: ['AB8092/upload'],
//               },
//             ],
//           },
//         },
//       },
//       {
//         notificationPayload: {
//           templateParams: {
//             body: {
//               params: [
//                 'Only',
//                 '27-Nov-2024',
//                 '2024-12-27 11:39:04.677752+00:00',
//               ],
//             },
//             header: {
//               params: [],
//             },
//             buttons: [
//               {
//                 params: ['AB8092/upload'],
//               },
//             ],
//           },
//           templateName: 'reim_claim_documents_requested_notify_final_v2',
//         },
//         deleteIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '!=',
//                 value: 'documents-requested',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//         type: 'reim-claim-documents-requested-followup-t+12',
//         sendIfConditionsTrue: [
//           {
//             conditions: [
//               {
//                 operator: '==',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '09-Dec-2024',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//           },
//         ],
//       },
//     ],
//     statusPageContent: {
//       highlight: {
//         backgroundColor: '#FFDE9E',
//         linkText: 'Upload documents',
//         subtitle: 'Submit them as soon as possible',
//         title: 'Plum is waiting for your documents',
//         redirectTo: '/claims/AB8092/upload',
//       },
//       list: [
//         {
//           stage: 'documents-requested',
//           title: 'Claim created',
//           subtitle: null,
//           eventDate: 'Created on 27-11-2024',
//           iconUrl:
//             'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/status-page-icons/done/documents-requested.png',
//           textColor: '#2D3D54',
//           flag: 'done',
//           type: 'MAJOR',
//           subtitle2: 'Created on 27-11-2024',
//         },
//         {
//           stage: 'documents-requested',
//           title: 'Document submission pending',
//           subtitle: 'Submit your documents',
//           eventDate: null,
//           iconUrl:
//             'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/status-page-icons/inProgress/small-green-dot.png',
//           textColor: '#2D3D54',
//           flag: 'inProgress',
//           type: 'MINOR',
//           subtitle2: null,
//         },
//         {
//           stage: 'documents-submitted',
//           title: 'Document submitted',
//           subtitle: null,
//           eventDate: null,
//           iconUrl:
//             'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/status-page-icons/pending/documents-submitted.png',
//           textColor: '#8C98AB',
//           flag: 'pending',
//           type: 'MAJOR',
//           subtitle2: null,
//         },
//         {
//           stage: 'documents-ok',
//           title: 'Document reviewed',
//           subtitle: null,
//           eventDate: null,
//           iconUrl:
//             'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/status-page-icons/pending/documents-ok.png',
//           textColor: '#8C98AB',
//           flag: 'pending',
//           type: 'MAJOR',
//           subtitle2: null,
//         },
//         {
//           stage: 'approved',
//           title: 'Claim approved',
//           subtitle: null,
//           eventDate: null,
//           iconUrl:
//             'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/status-page-icons/pending/approved.png',
//           textColor: '#8C98AB',
//           flag: 'pending',
//           type: 'MAJOR',
//           subtitle2: null,
//         },
//         {
//           stage: 'paid',
//           title: 'Money credited',
//           subtitle: null,
//           eventDate: null,
//           iconUrl:
//             'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/status-page-icons/pending/paid.png',
//           textColor: '#8C98AB',
//           flag: 'pending',
//           type: 'MAJOR',
//           subtitle2: null,
//         },
//       ],
//       claimDetailsForUI: [
//         {
//           type: 'user-details',
//           detailsList: [
//             {
//               iconUrl:
//                 'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/userIcons/employee-male.png',
//               title: 'Only  Spouse',
//               subtitle: 'Employee • 24 years',
//             },
//           ],
//         },
//         {
//           type: 'claim-details',
//           detailsList: [
//             {
//               iconUrl: null,
//               title: 'Total claim amount',
//               subtitle: '₹0',
//             },
//             {
//               iconUrl: null,
//               title: 'Reason for expense',
//               subtitle: 'test',
//             },
//             {
//               iconUrl: null,
//               title: 'Date of expense',
//               subtitle: '09 Nov 2024',
//             },
//           ],
//         },
//       ],
//     },
//     homePageContent: {
//       title: 'Plum is waiting for your documents',
//       redirectTo: '/claims/AB8092/upload',
//       backgroundColor: '#FFDE9E',
//       linkText: 'Upload documents',
//       subtitle: 'Submit them as soon as possible',
//     },
//     whatsAppClaimStatus: {
//       subtitle:
//         "We are waiting for documents submission from you. Please use this link to proceed with document submission: https://app.plumhq.com/claims/AB8092/. Once you've submitted the documents, Plum will review them and submit them to the insurer. After they've been submitted to the insurer, it might take up to 7-10 days for your to receive the reimbursement in your bank account.",
//       title: '*Status of your reimbursement claim for Only  Spouse*',
//       heading: 'Reimbursement claim for Only  Spouse created on 27-Nov-2024',
//     },
//     followupEmailNotifications: [
//       {
//         type: 'reim-claim-documents-requested-followup-t+1',
//         sendIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 operator: '==',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//               {
//                 operator: '>',
//                 value: '28-Nov-2024',
//                 variable: '__now',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//         notificationPayload: {
//           templateBody: {
//             templateAlias: 'Claim-Updates',
//             templateModel: {
//               content_below_button:
//                 "Please don't hesitate to reach out to us if you have any questions or concerns - you can email us at care@plumhq.com. We’re here to help you at every step of the way.<br><br>Best regards,<br>Plum Claims Team",
//               update_content:
//                 'Dear Only,<br><br>We hope this email finds you well.<br><br>We wanted to follow up on the claim you raised with us on 27-Nov-2024. We kindly request you to upload the required documents as soon as possible to avoid any delays in the processing of your claim. As per the insurer, the claim documents need to be submitted within 30 days of discharge.',
//               show_content_below_button: true,
//               button_name: 'Upload your documents',
//               button_url: 'https://app.plumhq.com/claims/AB8092/upload',
//               subject:
//                 'Urgent Request: Submit Documents for Your Claim Process',
//             },
//           },
//         },
//         deleteIfConditionsTrue: [
//           {
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '!=',
//                 value: 'documents-requested',
//               },
//             ],
//             reference: 'document',
//           },
//         ],
//       },
//       {
//         type: 'reim-claim-documents-requested-followup-t+2',
//         sendIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 operator: '==',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '29-Nov-2024',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//         notificationPayload: {
//           templateBody: {
//             templateAlias: 'Claim-Updates',
//             templateModel: {
//               button_url: 'https://app.plumhq.com/claims/AB8092/upload',
//               subject: 'Reminder: Submit Documents for Your Claim Process',
//               content_below_button:
//                 'If you have any questions or need further assistance, please email our Customer Care team at care@plumhq.com.<br><br>Best regards,<br>Plum Claims Team',
//               update_content:
//                 'Dear Only,<br><br>We hope this email finds you well. This is a gentle reminder to submit the necessary claim documents for your claim reimbursement request that you raised with us on 27-Nov-2024.<br><br>We understand that you may have a busy schedule. However, timely submission of the claim documents is essential to start the claim process. As per the insurer, the claim documents need to be submitted within 30 days of discharge.<br><br>Please take a moment to upload the required documents through the link below:',
//               show_content_below_button: true,
//               button_name: 'Upload your documents',
//             },
//           },
//         },
//         deleteIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 operator: '!=',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//       },
//       {
//         deleteIfConditionsTrue: [
//           {
//             conditions: [
//               {
//                 operator: '!=',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//           },
//         ],
//         type: 'reim-claim-documents-requested-followup-t+4',
//         sendIfConditionsTrue: [
//           {
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '==',
//                 value: 'documents-requested',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '01-Dec-2024',
//               },
//             ],
//             reference: 'document',
//           },
//         ],
//         notificationPayload: {
//           templateBody: {
//             templateAlias: 'Claim-Updates',
//             templateModel: {
//               content_below_button:
//                 'If you have any questions or need further assistance, please email our Customer Care team at care@plumhq.com<br><br>Best regards,<br>Plum Claims Team',
//               update_content:
//                 'Dear Only,<br><br>We hope this email finds you well. We wanted to follow up regarding the submission of your claim documents for the claim raised on 27-Nov-2024.<br><br>Please note that your claim reimbursement request cannot be processed until we receive the necessary documents. We request you to submit them as soon as possible to avoid any further delay in starting your claim process.',
//               show_content_below_button: true,
//               button_name: 'Upload your documents',
//               button_url: 'https://app.plumhq.com/claims/AB8092/upload',
//               subject: 'Reminder: Submit Documents for Your Claim Process',
//             },
//           },
//         },
//       },
//       {
//         deleteIfConditionsTrue: [
//           {
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '!=',
//                 value: 'documents-requested',
//               },
//             ],
//             reference: 'document',
//           },
//         ],
//         type: 'reim-claim-documents-requested-followup-t+7',
//         sendIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 operator: '==',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '04-Dec-2024',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//         notificationPayload: {
//           templateBody: {
//             templateAlias: 'Claim-Updates',
//             templateModel: {
//               content_below_button:
//                 'If you have any questions or need further assistance, please email our Customer Care team at care@plumhq.com<br>Thank you for your prompt attention to this matter.<br><br>Best regards,<br>Plum Claims Team',
//               update_content:
//                 'Dear Only,<br><br>We hope this email finds you well. We wanted to remind you about your pending insurance claim documents for the claim you raised on 27-Nov-2024 on Plum. If the necessary documents are not submitted within 30 days of discharge, the insurer may not honour the claim reimbursement request.<br><br>We urge you to take action immediately and upload your claim documents through the link below:',
//               show_content_below_button: true,
//               button_name: 'Upload your documents',
//               button_url: 'https://app.plumhq.com/claims/AB8092/upload',
//               subject:
//                 '[IMPORTANT] Urgent reminder: Submit Documents for your Claim Process',
//             },
//           },
//         },
//       },
//       {
//         deleteIfConditionsTrue: [
//           {
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 field: 'stage',
//                 operator: '!=',
//                 value: 'documents-requested',
//               },
//             ],
//             reference: 'document',
//             documentId: 'AB8092',
//           },
//         ],
//         type: 'reim-claim-documents-requested-followup-t+12',
//         sendIfConditionsTrue: [
//           {
//             documentId: 'AB8092',
//             collectionPath: 'claims',
//             conditions: [
//               {
//                 operator: '==',
//                 value: 'documents-requested',
//                 field: 'stage',
//               },
//               {
//                 variable: '__now',
//                 operator: '>',
//                 value: '09-Dec-2024',
//               },
//             ],
//             reference: 'document',
//           },
//         ],
//         notificationPayload: {
//           templateBody: {
//             templateAlias: 'Claim-Updates',
//             templateModel: {
//               content_below_button:
//                 'If we do not receive the document by 2024-12-27 11:39:04.677752+00:00, we will delete the claim request at our end. You can create a new claim ticket if you would like.<br><br>If you have any questions or concerns, our Customer Care team is available to assist you - email us at care@plumhq.com.<br><br>Best regards,<br>Plum Claims Team',
//               update_content:
//                 'Dear Only,<br><br>We hope this email finds you well. This is a final reminder regarding the submission of the necessary documents for your claim raised on 27-Nov-2024.<br><br>We understand that life can be busy, but we would like to stress the importance of submitting the documents on time. If the necessary documents are not submitted within 30 days of discharge, the insurer may not honour the claim reimbursement request.',
//               show_content_below_button: true,
//               button_name: 'Upload your documents',
//               button_url: 'https://app.plumhq.com/claims/AB8092/upload',
//               subject:
//                 '[IMPORTANT] Final Reminder: Submit Documents for Your Claim Process',
//             },
//           },
//         },
//       },
//     ],
//   },
//   redirectTo: '/claims/AB8092/upload',
//   assignedTo: null,
//   assignedToDate: null,
//   note: null,
//   queryType: null,
//   noteSourceText: null,
//   plumRejectionReason: null,
//   plumRejectionReasonType: null,
//   insurerRejectionReason: null,
//   insurerRejectionReasonType: null,
//   disputeReason: null,
//   disputeReasonType: null,
//   investigationReason: null,
//   investigationReasonType: null,
//   finalSettlementRejectionReason: null,
//   finalSettlementRejectionReasonType: null,
//   preAuthRejectionReason: null,
//   preAuthRejectionReasonType: null,
//   queryRaisedCounter: 0,
//   unFormattedQuery: null,
//   approvedLetterURL: null,
//   settlementLetterURL: null,
//   claimFormURL: null,
//   unFormattedDeductionReasons: null,
//   deductionReasons: null,
//   leadRejectionReason: null,
//   leadRejectionReasonType: null,
//   tatRevision: null,
//   tatUpdateReason: null,
//   tatUpdatedDate: null,
//   nextExpectedStage: null,
//   nextExpectedStageDate: null,
//   pendingOn: 'user',
//   courierDetailsList: null,
//   lastAPIIntegrationUpdate: null,
//   lastAPIIntegrationPickedAt: null,
//   lastAPIIntegrationUpdatedAt: null,
//   lastAPIIntegrationSyncAt: null,
//   lastAPIIntegrationStatus: null,
//   childClaimRelationList: null,
//   nextAllowedStepSlug: null,
//   digitisationHash: null,
//   userIPAddress: '14.195.56.18',
//   selectedPaymentAccountDetailId: null,
//   userOfflineClaimReason: null,
//   isAsyncClaimsRouterInProgress: null,
//   communicationPreference: {
//     email: 'testing+eesc@plumhq.com',
//     alternateEmail: null,
//     phoneNumber: '1100110011',
//     alternatePhoneNumber: null,
//   },
//   parentClaimRelation: null,
//   uiRepresentation: {
//     typeOfBenefit: {
//       value: 'Health expenses',
//     },
//     typeOfCare: {
//       value: 'OPD',
//     },
//     typeOfClaim: {
//       value: 'Reimbursement',
//     },
//     latestUpdate: {
//       text: 'Created at',
//       value: '2024-11-27T11:39:04.392399Z',
//     },
//     status: {
//       colorBackground: '#E2B266',
//       textColor: '#FFFFFF',
//       icon: {
//         svg: 'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/claim-status-tag-icons/draft/icon.svg',
//         png: 'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/claim-status-tag-icons/draft/icon.png',
//       },
//       value: 'In drafts',
//       valueCaps: 'IN DRAFTS',
//     },
//   },
//   documents: [
//     {
//       documentId: 'rLUnXJEPvx9vbS4h0C5c',
//       url: 'https://storage.googleapis.com/staging-plumhq-claim-documents/AB8092/rLUnXJEPvx9vbS4h0C5c/treatment-documents_1732707622.510885.jpg?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=firebase-adminsdk-2ujs8%40plum-663dd.iam.gserviceaccount.com%2F20241127%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20241127T114300Z&X-Goog-Expires=86400&X-Goog-SignedHeaders=host&X-Goog-Signature=05b45f356e1d46860c2615a2b73ed8d18eb3c8f9b4a9dada104d7094cb1b7eba2d8db59680c84ad8e033f2eff573b1ff62c5fa14b4b13cdba46ec5852186c5e5ebfc9d55bbb91e774a783823ea3da05622dd5b86e8deee63ae8408ae269fcf1fb39522dddc1901c8a2f3484f310c9b382d2b6f8203ef7d9f5011ab85d1577ca48437c9aab3ad7fcc6a57c3dbbfcc9df9c83958019af775cd82ed80464d0bed9e7ab3bfcf681b73a72ecd21283d3f36d6bfafae1464285c092e91100574956218f6ea092caf6811cca5fbddd12df515ae6223679985615ac5d6f7a2ca66e3adcc5c1d252282d5c3352e056a0c575561a453a5e5580fb20992b9eb347088ea1e81',
//       previewUrl: {
//         '64': 'https://storage.googleapis.com/staging-plumhq-claim-documents-thumbnails/AB8092/rLUnXJEPvx9vbS4h0C5c/64.png?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=firebase-adminsdk-2ujs8%40plum-663dd.iam.gserviceaccount.com%2F20241127%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20241127T114300Z&X-Goog-Expires=86400&X-Goog-SignedHeaders=host&X-Goog-Signature=1c731bd29450b5cc37fbdff00b00c89432a4465bf8b6b6920a60e57d96d9205cf033fbafc88575857c156482ee08ebc37e4faca5d7e72a068ba8b82d595f038258f653194afb0bf21a3ccac17a92d0ac72a43557df18e6db91e25b3bc23f007e6b645e527704e958e528444fb2abd7bc318409de79ff9559ba63f613faf91edd1392db7abe116b382731e4e91797a7c8cc55bacd89ca7414c203b0dbb863009b17f701de454c706bf08702a01947d3293446202b51600c5b2cb822b12330e733992f17979c88fdc76cf8ffd00005335071057f0a297c8b750c1bd19e7207e187ed5d89a5d85bd0a36d5004c1e817fb80343980f05a2a36dbc905380269303b49',
//         preview:
//           'https://storage.googleapis.com/staging-plumhq-claim-documents-previews/AB8092/rLUnXJEPvx9vbS4h0C5c/preview.png?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=firebase-adminsdk-2ujs8%40plum-663dd.iam.gserviceaccount.com%2F20241127%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20241127T114300Z&X-Goog-Expires=86400&X-Goog-SignedHeaders=host&X-Goog-Signature=3a6759dec7de7f16aa23683ad2affba03afc4d3f4b01f8009e1dfc84f074de150500520616217f3d557d1648416ee2c1509eaf6fac7d8aea0b8bd2a1053bf16005e28ac3b0a448199ec53d173670cf57bb028d7132c8b2973b9ed072422cf018a03783fe708aee7cc62695dd63b639bb296206c62737d55f78269f5b256baed9ac91e7ffba4ec896df870badfb2cdbca29338559d9f0c749991eb0ff4655b4bade2dee10086420a37b491612510fc7b23373a809d32e25b643b5f0c3cb48cf3cf0c194b2a5f5b4e4635257cea6c663c36414e8462ac150db49e3bb5c2a280513049d6d895c61511a1e337a94090c4fd9c3589a7ff1bd30680d16002e83f82bae',
//       },
//       timeSinceUploadText: '2 minutes ago',
//       name: 'treatment-documents_1732707622.510885.jpg',
//       attrs: {
//         relation: 'self',
//       },
//       providerDMSFileURL: null,
//       providerDMSFilePath: null,
//       sectionTag: 'treatment-documents',
//       createdAt: '2024-11-27T11:40:22.930920Z',
//       preFilled: false,
//       contentHash:
//         '9eaecc90afe3c24a6cfa50d163afef216f4f7ab2671f7069ac5ef92a3975d2b9fa833388deec0f4eaf3c32ddda495c7d32ad3c3a7458fa0297d45d667e39e887',
//     },
//   ],
//   courierDetailPage: {
//     address: null,
//     addressHTML: null,
//     fields: [
//       {
//         type: 'date',
//         label: 'Date of courier',
//         placeholder: 'Select a date of courier',
//         name: 'courierDate',
//       },
//       {
//         type: 'text',
//         label: 'Tracking No.',
//         placeholder: 'PCD12345678',
//         name: 'courierTrackingNo',
//       },
//       {
//         type: 'text',
//         label: 'Courier service provider name',
//         placeholder: 'BlueDart, Delhivery, DTDC',
//         name: 'courierProvider',
//       },
//     ],
//   },
//   documentsUploadPageContent: [
//     {
//       order: 1,
//       claimAmountPrompt: {
//         title: 'Enter your claim amount',
//         walletBalance: null,
//         inputFields: [
//           {
//             order: 1,
//             maskCharacters: 'false',
//             label: null,
//             min: 1,
//             max: null,
//             regex: '^[1-9][0-9]+$',
//             hint: 'Please ensure you also upload bills and receipts for the claim amount above',
//             disabled: false,
//             maxTextLength: 10,
//             type: 'number',
//             confirmField: null,
//             value: null,
//             errorMessage: null,
//             placeholder: 'Enter claim amount',
//             name: 'amount',
//           },
//         ],
//       },
//       subtitle: 'Upload all documents under their relevant sections',
//       title: 'Claim details and documents',
//       slug: 'treatment-documents',
//       instructions: {
//         iconUrl:
//           'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/upload-page-icons/misc/light_bulb.png',
//         previewDocs: {
//           mediaType: null,
//           allowSkip: true,
//           mediaUrl: null,
//           thumbnailUrl: null,
//           autoplay: false,
//         },
//         dontsList: [],
//         title: 'Keep these in mind',
//         eventName: 'claims-intro-video-viewed',
//         dosList: [],
//         dosIconUrl:
//           'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/upload-page-icons/misc/dos_icon.png',
//         dontsIconUrl:
//           'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/upload-page-icons/misc/donts_icon.png',
//         htmlText:
//           'No need to courier document hard copies. Plum OPD is completely digital, so scanned or digital copies of your documents are acceptable',
//       },
//       name: 'Claim details and documents',
//       categories: [
//         {
//           iconUrl:
//             'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/document-categories/bills-and-payment-receipts/144x144.png',
//           title: 'Bills and payment receipts',
//           slug: 'bills-and-payment-receipts',
//           sections: [
//             {
//               iconUrl:
//                 'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/document-sections/treatment-documents/144x144.png',
//               required: true,
//               title: 'Bills and payment receipts',
//               forms: [],
//               sampleDocuments: [
//                 {
//                   downloadButtonText: 'View sample',
//                   title:
//                     'Please self-attest original bills and receipts before uploading',
//                   url: 'https://storage.googleapis.com/plumhq-claim-sample-documents-india/Self_attestation_ICICI_Lombard.jpg',
//                 },
//               ],
//               sectionTag: 'treatment-documents',
//               upload: {
//                 hint: 'You can upload multiple documents. Make sure each is less than 10 MB.',
//                 buttonText: 'Upload Bills/Payment Receipts',
//                 allowedFileTypes: [
//                   'image/jpeg',
//                   'image/jpg',
//                   'image/png',
//                   'application/pdf',
//                 ],
//                 maxFileSizeMB: 10,
//               },
//               instructions: {
//                 dosIconUrl:
//                   'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/upload-page-icons/misc/dos_icon.png',
//                 dosList: [],
//                 dontsIconUrl:
//                   'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/upload-page-icons/misc/donts_icon.png',
//                 htmlText:
//                   'Be sure to upload bills matching your total claim amount ₹ (actual claim amount)\nwith the patient name (Only  Spouse) clearly mentioned on each bill.',
//                 iconUrl:
//                   'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/upload-page-icons/misc/light_bulb.png',
//                 previewDocs: {
//                   allowSkip: true,
//                   mediaType: 'video',
//                   mediaUrl:
//                     'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/instructions-videos/bills-receipts-v1.mp4',
//                   thumbnailUrl:
//                     'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/instructions-images/bill-receipts-thumbnail.gif',
//                   autoplay: false,
//                 },
//                 dontsList: [],
//                 title: 'Getting this right',
//                 eventName: null,
//               },
//               faqs: [],
//               skipSection: null,
//               checkboxes: [
//                 {
//                   text: "I've uploaded bills adding up to my entire claim amount of ₹ (actual claim amount)",
//                   value: false,
//                   errorMessage: 'Please check all the required checkboxes',
//                   required: true,
//                   name: 'bills-payment-receipts-checkbox_1',
//                   type: 'checkbox',
//                 },
//                 {
//                   type: 'checkbox',
//                   value: false,
//                   text: "I've uploaded receipts matching my entire claim amount of ₹ (actual claim amount)",
//                   errorMessage: 'Please check all the required checkboxes',
//                   name: 'bills-payment-receipts-checkbox_2',
//                   required: true,
//                 },
//               ],
//               digitisationInputTitle: null,
//               digitisationInputFields: null,
//               order: 1,
//               userUploadDirections: null,
//               hasToBeVerified: true,
//               requestDependentDocs: false,
//               stepInline: true,
//               documentsToUpload: {
//                 title: 'Documents you can upload',
//                 documentsList: [
//                   'Medical Bills/Invoices',
//                   'Hospital Invoices',
//                   'Cash Receipts',
//                   'Hospital Invoices',
//                   'Medical Bills/Invoices',
//                   'Cash Receipts',
//                 ],
//               },
//             },
//           ],
//           order: 2,
//           instructions: null,
//         },
//       ],
//     },
//     {
//       paymentSelector: {
//         title: 'Set up my payment method',
//         availablePaymentOptions: ['MOBILE_NUMBER', 'VPA', 'BANK_ACCOUNT'],
//         subtitle:
//           "Ensure that you are using an account that is in the employee's name",
//       },
//       subtitle: 'Payments will be transferred to the account you setup here',
//       title: 'Your account details',
//       slug: 'kyc-documents',
//       instructions: null,
//       name: 'Account details',
//       order: 2,
//       categories: [],
//     },
//     {
//       order: 3,
//       displayAsNonStep: true,
//       subtitle: 'One last step, all you have to do is sign your form!',
//       inputFieldGroups: [],
//       title: 'Review and sign',
//       checkboxes: [
//         {
//           name: 'declaration-correct-information',
//           required: true,
//           type: 'checkbox',
//           text: 'I hereby declare that the information furnished is true & correct to he best of our knowledge and belief',
//           value: false,
//           errorMessage: 'Please check all the required checkboxes',
//         },
//       ],
//       signatureRequired: true,
//       slug: 'review',
//       claimDetailsForUI: [
//         {
//           type: 'user-details',
//           detailsList: [
//             {
//               iconUrl:
//                 'https://storage.googleapis.com/plumhq-claims-assets-india/default/default/userIcons/employee-male.png',
//               title: 'Only  Spouse',
//               subtitle: 'Employee • 24 years',
//             },
//           ],
//         },
//         {
//           type: 'claim-details',
//           detailsList: [
//             {
//               iconUrl: null,
//               title: 'Total claim amount',
//               subtitle: '₹0',
//             },
//             {
//               iconUrl: null,
//               title: 'Reason for expense',
//               subtitle: 'test',
//             },
//             {
//               iconUrl: null,
//               title: 'Date of expense',
//               subtitle: '09 Nov 2024',
//             },
//           ],
//         },
//       ],
//       instructions: null,
//       name: 'Review',
//       categories: [],
//     },
//   ],
// });

export const claimDetailsQuery = ({
  claimId,
  returnStatusContent = true,
  returnCourierDetailsPage = true,
  returnDocumentsUploadPageContent,
}: {
  claimId: string;
  returnStatusContent?: boolean;
  returnCourierDetailsPage?: boolean;
  returnDocumentsUploadPageContent?: number;
}): IQuery<IClaimDetails> => ({
  queryKey: [
    'claim-details',
    claimId,
    returnStatusContent,
    returnCourierDetailsPage,
    returnDocumentsUploadPageContent,
  ],
  queryFn: async () => {
    const { organisationId, memberId } = decodeAuthToken() ?? {};
    if (!claimId || organisationId == null || memberId == null) {
      throw new Error('Invalid claimId or organisationId or memberId');
    }
    let url = `/organisation/${organisationId}/member/${memberId}/claim/${claimId}?memberId=${memberId}&uiRepresentation=web`;
    if (returnStatusContent) {
      url += '&returnStatusContent=true';
    }
    if (returnCourierDetailsPage) {
      url += '&returnCourierDetailsPage=true';
    }
    if (returnDocumentsUploadPageContent != null) {
      url += `&returnDocumentsUploadPageContent=${returnDocumentsUploadPageContent}`;
      // return await sleep(1000, getMockClaimDetails());
    }
    const claimDetails = await claimsAxiosInstance.get<IClaimDetails>(url);
    return claimDetails.data;
  },
});

export const updateClaimDetails = ({
  claimId,
  returnStatusContent = true,
  returnCourierDetailsPage = true,
  returnDocumentsUploadPageContent,
}: {
  claimId: string;
  returnStatusContent?: boolean;
  returnCourierDetailsPage?: boolean;
  returnDocumentsUploadPageContent?: number;
}): IMutationQuery<IClaimDetails> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    mutationKey: [],
    // @ts-ignore
    mutationFn: async ({ payload, params }) => {
      let url = `/organisation/${organisationId}/member/${memberId}/claim/${claimId}?memberId=${memberId}&uiRepresentation=web`;
      if (returnStatusContent) {
        url += '&returnStatusContent=true';
      }
      if (returnCourierDetailsPage) {
        url += '&returnCourierDetailsPage=true';
      }
      if (returnDocumentsUploadPageContent != null) {
        url += `&returnDocumentsUploadPageContent=${returnDocumentsUploadPageContent}`;
      }
      if (Object.keys(params).length > 0) {
        url += `&${new URLSearchParams(params).toString()}`;
      }
      const claimDetails = await claimsAxiosInstance.put<IClaimDetails>(
        url,
        payload,
      );
      return claimDetails.data;
    },
  };
};

export const claimsListQuery = (
  stageGroup: EClaimCreationStatus,
  pageSize = 10,
): IQuery<IClaimsListQuery> => ({
  queryKey: ['allClaims', stageGroup, pageSize],
  queryFn: async ({ pageParam = 1 }) => {
    const { organisationId, memberId } = decodeAuthToken() ?? {};
    const url = `/organisation/${organisationId}/member/${memberId}/claim?memberId=${memberId}&stageGroup=${stageGroup}&page=${pageParam}&pageSize=${pageSize}&uiRepresentation=web`;
    const claimsList = await claimsAxiosInstance.get<IClaimsListQuery>(url);
    return claimsList.data;
  },
});

export const allClaimsQuery = (): IQuery<IAllClaimsListQuery['claimsList']> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    queryKey: ['allClaims', organisationId, memberId],
    queryFn: async () => {
      const url = `/organisation/${organisationId}/member/${memberId}/claim`;
      const [activeClaims, draftClaims, pastClaims] = await Promise.allSettled([
        claimsAxiosInstance.get<IClaimsListQuery>(
          `${url}?memberId=${memberId}&stageGroup=${EClaimCreationStatus.ACTIVE}&page=1&pageSize=10`,
        ),
        claimsAxiosInstance.get<IClaimsListQuery>(
          `${url}?memberId=${memberId}&stageGroup=${EClaimCreationStatus.DRAFTS}&page=1&pageSize=10`,
        ),
        claimsAxiosInstance.get<IClaimsListQuery>(
          `${url}?memberId=${memberId}&stageGroup=${EClaimCreationStatus.PAST}&page=1&pageSize=10`,
        ),
      ]);
      return {
        activeClaims:
          activeClaims.status === 'fulfilled' ? activeClaims.value.data : [],
        draftClaims:
          draftClaims.status === 'fulfilled' ? draftClaims.value.data : [],
        pastClaims:
          pastClaims.status === 'fulfilled' ? pastClaims.value.data : [],
      };
    },
  };
};

export const importClaimsQuery = (
  patientId: string | null,
): IQuery<IImportedCashlessClaims> => ({
  queryKey: ['importedClaims', patientId],
  queryFn: async () => {
    if (patientId && !window.devTools.isDevFlagSet(EDevFlag.CREATE_CLAIM)) {
      const { organisationId, memberId } = decodeAuthToken() ?? {};
      const url = `/organisation/${organisationId}/member/${memberId}/claim/find-open-cashless-claims?patientId=${patientId}&memberId=${memberId}`;
      const importedClaims =
        await claimsAxiosInstance.get<IImportedCashlessClaims>(url);
      return importedClaims.data;
    }
    return {
      results: [],
      status: 'failed',
      claimsDataSource: null,
    };
  },
  staleTime: 0,
  cacheTime: 0,
});

export const createInsurerClaim = (
  insurerClaimId: string,
  patientId: string,
  source: string,
): IMutationQuery<IClaimDetails> => ({
  mutationKey: [insurerClaimId, patientId],
  mutationFn: async () => {
    const { organisationId, memberId } = decodeAuthToken() ?? {};
    const url = `/organisation/${organisationId}/member/${memberId}/claim/create-from-insurer-data?memberId=${memberId}`;
    const payload = {
      insurerClaimId,
      patientId,
      memberId,
      source,
    };
    const claimDetails = await claimsAxiosInstance.post<IClaimDetails>(
      url,
      payload,
    );
    if (claimDetails.status === 200 || claimDetails.status === 201) {
      await queryClient.invalidateQueries({
        refetchType: 'all',
        queryKey: ['allClaims'],
      });
    }
    return claimDetails.data;
  },
});

export interface IClaimCreatePayload {
  memberId: string;
  memberName: string;
  organisationId: string;
  organisationName: string;
  patientId: string;
  patientName: string;
  patientRelationship: EPatientRelationship | null;
  amount: number;
  source: string;
  typeOfClaim: EClaimType;
  typeOfCare: ECareType | null;
  reasonForHospitalization: string;
  communicationPreference: {
    email: string;
    phoneNumber: string;
    alternatePhoneNumber?: string;
    alternateEmail?: string;
  };
  hospital?: {
    hospitalname?: string | null;
    hospitalid?: string | null;
  };
  insuranceProviderHandle: string | null;
  tpaName: string | null;
  organisationBenefitId: string | null;
  typeOfBenefit?: string | null;
  treatmentStage?: string;
  date: string;
  tentativeDays?: string | null;
  dateFieldName?: string;
}

export const createPlumClaim = (): IMutationQuery<IClaimDetails | null> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    mutationKey: [Date.now()],
    // @ts-ignore
    mutationFn: async (payload: IClaimCreatePayload | null) => {
      const url = `/organisation/${organisationId}/member/${memberId}/claim?memberId=${memberId}`;
      if (organisationId && memberId && payload != null) {
        const createPayload: Partial<IClaimCreatePayload> &
          Record<string, unknown> = {
          ...payload,
        };
        const { date, tentativeDays, dateFieldName } = payload;
        if (dateFieldName) {
          let dateObject = new Date(date);
          if (tentativeDays != null && !Number.isNaN(Number(tentativeDays))) {
            dateObject = addDays(dateObject, Number(tentativeDays));
          }
          const dateString = dateObject.toISOString();
          const plumDateObject = {
            day: dateObject.getDate(),
            month: dateObject.getMonth() + 1,
            year: dateObject.getFullYear(),
          };
          createPayload[`${dateFieldName}`] = dateString;
          createPayload[`${dateFieldName}Object`] = plumDateObject;
          createPayload[
            `tentativeDaysTo${dateFieldName?.[0]?.toUpperCase?.()}${dateFieldName?.slice?.(
              1,
            )}`
          ] = Number(tentativeDays) ?? null;
          delete createPayload.date;
          delete createPayload.tentativeDays;
          delete createPayload.dateFieldName;
        }

        const claimDetails = await claimsAxiosInstance.post<IClaimDetails>(
          url,
          createPayload,
        );
        if (claimDetails.status === 200 || claimDetails.status === 201) {
          await queryClient.invalidateQueries({
            refetchType: 'all',
            queryKey: ['allClaims'],
          });
        }
        return claimDetails.data;
      }
      return null;
    },
  };
};

export const deletePlumClaim = (
  plumClaimId: string,
): IMutationQuery<IClaimDetails | null> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    mutationKey: [Date.now()],
    mutationFn: async () => {
      const url = `/organisation/${organisationId}/member/${memberId}/claim/${plumClaimId}?memberId=${memberId}`;
      if (organisationId && memberId && plumClaimId != null) {
        const claimDetails = await claimsAxiosInstance.put<IClaimDetails>(url, {
          stage: 'deleted',
        });
        if (claimDetails.status === 200 || claimDetails.status === 201) {
          await queryClient.invalidateQueries({
            refetchType: 'all',
            queryKey: ['allClaims'],
          });
        }
        return claimDetails.data;
      }
      // return await sleep(1400, { stage: 'deleted' }, true);
      return null;
    },
  };
};

export const getClaimsCount = (): IQuery<IClaimsCount> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    queryKey: [],
    queryFn: async () => {
      const url = `/organisation/${organisationId}/member/${memberId}/claim/get-claims-stage-group-count?memberId=${memberId}`;
      const claimsCount = await claimsAxiosInstance.get<IClaimsCount>(url);
      return claimsCount.data;
    },
  };
};

export const getAvailableClaimTypes = (): IQuery<
  Array<IAvailableClaimType>
> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    queryKey: ['availableClaimTypes', memberId, organisationId],
    queryFn: async () => {
      const url = `/members/organisation/${organisationId}/member/${memberId}/get-available-claim-types?organisationId=${organisationId}`;
      const availableClaimTypes =
        await gatewayAxiosInstance.get<Array<IAvailableClaimType>>(url);
      return availableClaimTypes.data;
    },
  };
};

export const generateSignedUrl = ({
  claimId,
}: {
  claimId: string;
}): IMutationQuery<ISignedUrl> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    mutationKey: [],
    mutationFn: async (payload) => {
      window.dev.i('GENERATING SIGNED URL', payload);
      const url = `/organisation/${organisationId}/member/${memberId}/claim/${claimId}/document/`;
      const signedUrl = await claimsAxiosInstance.post<ISignedUrl>(
        url,
        payload,
      );
      return signedUrl.data;
    },
  };
};

export const deleteClaimDocument = ({
  claimId,
}: {
  claimId: string;
}): IMutationQuery<void> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    mutationKey: [],
    // @ts-ignore
    mutationFn: async ({ documentId }: { documentId: string }) => {
      const url = `/organisation/${organisationId}/member/${memberId}/claim/${claimId}/document/${documentId}/`;
      await claimsAxiosInstance.delete(url);
      await queryClient.invalidateQueries({
        queryKey: ['claim-details', claimId],
        type: 'active',
      });
    },
  };
};

export const createCallbackRequest = ({
  claimId,
}: {
  claimId: string;
}): IMutationQuery<Partial<IClaimPNRD>> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};

  return {
    mutationKey: [],
    // @ts-ignore
    mutationFn: async (payload: { reason: string }) => {
      const url = `/organisation/${organisationId}/member/${memberId}/claim/${claimId}/set-pnrd`;
      const response = await claimsAxiosInstance.post<{ pnrd: IClaimPNRD }>(
        url,
        payload,
      );
      await queryClient.setQueryData(
        claimDetailsQuery({ claimId }).queryKey,
        (prev: IClaimDetails) => {
          return {
            ...prev,
            pnrd: { ...(response?.data?.pnrd ?? null), source: 'new' },
          };
        },
      );
      return response?.data?.pnrd ?? null;
    },
  };
};
